import type { Response, ExecutiveResponse } from '@/lib/apollo/query/getExecutives/query'

import type { TransformedExecutiveData, TransformedData } from './types'

export const toTransformedExecutiveData = (
  executive: ExecutiveResponse,
): TransformedExecutiveData => ({
  ...executive,
  skillLevel: executive.skillLevel ?? undefined,
})

export const toTransformedData = (response?: Response): TransformedData | undefined =>
  response === undefined
    ? undefined
    : {
        ...response.getExecutives,
        results: response.getExecutives.results.map(toTransformedExecutiveData),
      }
